import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';

const KEY_OBJECT = "fieldName";
const VALUE_OBJECT = "value";

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const IS_LOCAL = false;

const SELECTOR_WRAPPER = '.p-park-activator-eoi';
const SELECTOR_PARK_FORM = '.p-park-activator-eoi__form';
const SELECTOR_PARK_FORM_BUTTON = '.p-park-activator-eoi__content-button';
const SELECTOR_EOI_WRAPPER = '.p-park-activator-eoi__wrapper';
const SELECTOR_SUCCESS_WRAPPER = '.p-park-activator-eoi__success-wrapper';
class ParkActivatorEOI {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		this.formElementsList = {};
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() { 
        return this._stepsData; 
    }

    set stepsData(_stepsData) { 
        this._stepsData = _stepsData; 
		if(_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
    }

	init() {
		this.parkEOIForm = SelectorEngine.findOne(SELECTOR_PARK_FORM, this._wrapper);
		this.parkEOIFormButton = SelectorEngine.findOne(SELECTOR_PARK_FORM_BUTTON, this._wrapper);
		this.parkEOIWrapper = SelectorEngine.findOne(SELECTOR_EOI_WRAPPER, this._wrapper);
		this.parkEOISuccessWrapper = SelectorEngine.findOne(SELECTOR_SUCCESS_WRAPPER, this._wrapper);
		this.fetchParkActivatorEOISteps();
		EventHandler.on(this.parkEOIFormButton, CLICK_EVENT, async () => {
			const isFormValid = await this.formGenerator.formValidation();
			if(isFormValid) {
				this.saveParkActivatorEOISteps(this.answerList);
			}
		});
	}
	showSuccessPage() {
		this.parkEOIWrapper.classList.add(HIDDEN_CLASS);
		this.parkEOISuccessWrapper.classList.remove(HIDDEN_CLASS);
	}
	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.parkEOIForm, {
			questions: stepsData,
			totalSteps: 3,
			hasSeparator: false,
			formType: FormTypes.SectionForm,
			themeColor: "color-lta-accent-orange",
			isHideProgress: true,
			isRenderDependentQuestion: true
		});
		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});
	}
	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				}
			}
		}
	}
	async fetchParkActivatorEOISteps() {
		try { 
			const url = "/api/eoi/steps";
			const response = await Request.get(url, {}, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Steps, error } = response;
			if(Steps) {
				this.stepsData = Steps
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
	async saveParkActivatorEOISteps(requestObject) {
		try { 
			const url = "/api/eoi/eoisave";
			const response = await Request.post(url, requestObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 	}
			});
			const { Success, success, error } = response;
			if(Success || success) {
				this.showSuccessPage();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
}

const globalParkActivatorEOI = new ParkActivatorEOI();
export default globalParkActivatorEOI;